// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"8469080a","530":"3856d420","552":"28aa750d","557":"15cfe30f","672":"cb6796dc","761":"69787632"}[chunkId] + ".chunk.css";
};